__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "@immense-ui/shell";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "0.21.4", function() { return __webpack_require__.e(674).then(function() { return function() { return __webpack_require__(1674); }; }); });
			register("react-cookie", "4.0.3", function() { return Promise.all([__webpack_require__.e(560), __webpack_require__.e(510)]).then(function() { return function() { return __webpack_require__(5560); }; }); });
			register("react-dom", "16.14.0", function() { return Promise.all([__webpack_require__.e(457), __webpack_require__.e(510)]).then(function() { return function() { return __webpack_require__(2457); }; }); });
			register("react-query", "3.16.0", function() { return Promise.all([__webpack_require__.e(67), __webpack_require__.e(510), __webpack_require__.e(529)]).then(function() { return function() { return __webpack_require__(1067); }; }); });
			register("react-router-dom", "5.2.0", function() { return Promise.all([__webpack_require__.e(213), __webpack_require__.e(510)]).then(function() { return function() { return __webpack_require__(5213); }; }); });
			register("react", "16.14.0", function() { return __webpack_require__.e(204).then(function() { return function() { return __webpack_require__(6204); }; }); });
			initExternal(7646);
			initExternal(9611);
			initExternal(6686);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};